import {AppService} from 'app/services/app.service';
import {AfterViewInit, Component, OnInit, OnDestroy} from '@angular/core';
import {NavigationService} from 'app/services/navigation.service';
import {Subscription} from 'rxjs';
import {UserModelService} from 'app/models/user-model.service';
import {HelperService} from '../services/helper.service';

@Component({
  template: ''
})
export abstract class MainComponent implements AfterViewInit, OnInit, AfterViewInit, OnDestroy {

  public HelperService = HelperService;
  public objectKeys = Object.keys;
  public objectValue = Object.values;
  public appService: AppService;
  public navigationService: NavigationService;
  public userModelService: UserModelService;

  protected subscriptions: Subscription[] = [];

  constructor(
    appService: AppService,
    navigationService: NavigationService,
    userModelService: UserModelService,
  ) {

    this.appService = appService;
    this.navigationService = navigationService;
    this.userModelService = userModelService;

  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      for (const subscription of this.subscriptions) {
        subscription.unsubscribe();
      }

      this.subscriptions = [];
    }
  }

  ionViewDidEnter() {
  }
}
